<template>
  <div>
    <EditUnit v-if="openEdit" :unitId="unitSelect" @close="closeUnit" />

    <UnitsByConfigPull  v-if="!openEdit" @selectUnit="openUnit"/>

  </div>

</template>

<script>

import UnitsByConfigPull from "@/components/UnitsByConfigPull";
import EditUnit from "@/components/EditUnit";

export default {
  name: "Monitor",

  data: function() {
    return {
        openEdit: null,
      unitSelect: null,

    };
  },

  computed: {},

  methods: {
        openUnit(id) {
      this.openEdit = true;
      this.unitSelect = id;
    },
        closeUnit() {
      this.openEdit = false;
      this.unitSelect = null;
    },
  },

  beforeMount() {
  },

  components: {
      UnitsByConfigPull,
      EditUnit

  },
};
</script>
